<template>
    <div>
        <MenuStorage/>
        <Damaged_stock/>
    </div>
</template>

<script>

    import MenuStorage from "@/components/admin/stock/menustorage/MenuStorage.vue";
    import Damaged_stock from "@/components/admin/stock/storage_damaged/Damaged_stock.vue";
    export default {
        name: "DamagedStorage",
        components: {
            Damaged_stock,
            MenuStorage

        }
    }
</script>

<style scoped>

</style>
